module.exports = __webpack_public_path__ + "static/media/twilio.f49730f4.jpg";